import moment from 'dayjs';
import isBetween from 'dayjs/plugin/isBetween';

moment.extend(isBetween);

export default {
  computed: {
    now() {
      const now = new Date();
      const imitationDate = (
        this.$store.state.session?.session?.preview_campaign
        && this.$store.state.session.session.preview_campaign.imitation_date
      );
      if (imitationDate) {
        return new Date(imitationDate);
      }
      return now;
    },
    showBlackFridayRoadblock() {
      const showBlackFridayRoadBlock = process.env.SHOW_BLACK_FRIDAY_ROADBLOCK;

      // hide it no matter we are in the corresponding dates
      if (!showBlackFridayRoadBlock) { return false; }

      const now = moment(this.now);
      const startDate = moment('2021-09-15T17:00:00.000-06:00');
      const endDate = moment('2021-11-17T12:00:00.000-06:00');

      return now.isBetween(startDate, endDate, null, '[)');
    },
    showBlackFridayEmailRoadblock() {
      const now = this.$route.query.show_bf_roadblock
        ? moment('2021-11-24T17:00-06:00') : moment(new Date());

      const startDate = moment('2021-11-21T17:00:00.000-06:00');
      const endDate = moment('2021-11-30T12:00:00.000-06:00');

      return now.isBetween(startDate, endDate, null, '[)');
    },
  },
  methods: {
    isCampaignActive(slug) {
      const { campaigns } = this.$store.getters;

      return (campaigns || []).includes(slug);
    },
  },
};
